// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zckr060 {
  gap: var(--_18w76bwh);
  display: flex;
  width: 100%;
}
.zckr061 {
  flex-basis: 100%;
}
.zckr062 {
  flex-basis: 100%;
}
@media screen and (min-width: 768px) {
  .zckr061 {
    flex-basis: calc(70% - 10px);
  }
  .zckr062 {
    flex-basis: calc(30% - 10px);
    max-width: 360px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;AACF","sourcesContent":[".zckr060 {\n  gap: var(--_18w76bwh);\n  display: flex;\n  width: 100%;\n}\n.zckr061 {\n  flex-basis: 100%;\n}\n.zckr062 {\n  flex-basis: 100%;\n}\n@media screen and (min-width: 768px) {\n  .zckr061 {\n    flex-basis: calc(70% - 10px);\n  }\n  .zckr062 {\n    flex-basis: calc(30% - 10px);\n    max-width: 360px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
